import { Component } from '@angular/core';
import { GoogleAccount } from './google-account.model';
import { BreadcrumbService } from '../../../../breadcrumb.service';
import { RouterConst } from '../../../../globals/RoutersConst';
import { ClientsService } from '../../../../services/clients/clients.service';
import { SuperClass } from '../../../../superclass/SuperClass';
import { WsService } from '../../../../services/websocket/WsService';
import { DashboardDataService } from '../../../../services/dashboard-data.service';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';

@Component({
  selector: 'app-google-accounts',
  templateUrl: './google-accounts.component.html',
  styleUrls: ['./google-accounts.component.css'],
})
export class AnalyticsGoogleAccountsComponent extends SuperClass {
  selectedRow: GoogleAccount;
  newAccount: GoogleAccount;
  newAccountForm: FormGroup;
  selectedRowForm: FormGroup;
  display = false;
  accounts: GoogleAccount[];

  constructor(
    private breadcrumbService: BreadcrumbService,
    private dashboardDataService: DashboardDataService,
    private clientsService: ClientsService,
    private wsService: WsService,
    private httpClient: HttpClient,
    private cookiesService: CookieService,
    private fb: FormBuilder,
  ) {
    super(
      clientsService,
      wsService,
      dashboardDataService,
      httpClient,
      cookiesService,
    );

    this.breadcrumbService.setItems([
      { label: 'Organization' },
      { label: 'Accounts' },
      {
        label: 'Google Accounts',
        routerLink: [
          { outlets: { sub: [RouterConst.ANALYTICS_GOOGLE_ACCOUNTS] } },
        ],
      },
    ]);
    this.newAccount = new GoogleAccount();
  }

  getWebSocketIdentifier(): string {
    return undefined;
  }

  reloadData() {
    this.http_getAllAccounts('google', (response: any) => {
      this.accounts = response.payload;
    });

    this.selectedRowForm = this.fb.group({
      name: new FormControl('', Validators.required),
      googleClientId: new FormControl('', Validators.required),
    });

    this.newAccountForm = this.fb.group({
      name: new FormControl('', Validators.required),
      googleClientId: new FormControl('', Validators.required),
    });
  }

  selectRow(e) {
    this.selectedRow = new GoogleAccount(e.data);
  }

  saveAccount() {
    // const requiredFields = [
    //   {id: 'name', value: this.selectedRow.name, fieldName: 'Name'},
    //   {id: 'google_client_id', value: this.selectedRow.clientId, fieldName: 'Client ID'}
    // ];
    // if (this.hasEmptyFields(requiredFields)) {
    //   return;
    // }

    this.http_updateAccounts(this.selectedRow, 'google', (data: any) => {
      this.showSuccessMessage('Account has been updated');
      this.unselectRow();
      this.accounts = data.payload;
    });
  }

  addNewAccount() {
    this.display = true;
    this.newAccount = new GoogleAccount();
  }

  createNewAccount() {
    // const requiredFields = [
    //   {id: 'new_name', value: this.newAccount.name, fieldName: 'Name'},
    //   {id: 'new_google_client_id', value: this.newAccount.googleClientId, fieldName: 'Client ID'}
    // ];
    // if (this.hasEmptyFields(requiredFields)) {
    //   return;
    // }

    this.http_addAccount(this.newAccount, 'google', (data: any) => {
      this.showSuccessMessage('Account has been created');
      this.unselectRow();
      this.accounts = data.payload;
    });
    this.display = false;
  }

  deleteAccount() {
    this.http_deleteAccount(this.selectedRow, 'google', (data: any) => {
      this.showSuccessMessage('Account has been deleted');
      this.unselectRow();
      this.accounts = data.payload;
    });
  }

  unselectRow() {
    this.selectedRow = undefined;
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/accounts/google-accounts/google-accounts.component.ts